(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`._tooltip_1u1u7_1{cursor:default;word-break:break-all;word-wrap:break-word;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}._placeholderTooltip_1u1u7_10{max-width:300px}._placeholderTagChip_1u1u7_14{justify-content:center;transition:background .15s ease-in-out;display:flex}._placeholderTagChip_1u1u7_14:hover{background:var(--dixa-color-neutral-200)}._chips_1u1u7_23{flex-wrap:nowrap}@media (width>=768px){._chips_1u1u7_23{flex-wrap:wrap}}._hiddenTagsDropdown_1u1u7_32{max-width:100vw}/*$vite$:1*/`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();
import { DropdownButton as e, FlexBox as t, Tag as n, Tooltip as r } from "@dixa/lib-shared-habla";
import i from "classnames";
import { useMemo as a } from "react";
import { Fragment as o, jsx as s, jsxs as c } from "react/jsx-runtime";
var l = {
	tooltip: "_tooltip_1u1u7_1",
	placeholderTooltip: "_placeholderTooltip_1u1u7_10",
	placeholderTagChip: "_placeholderTagChip_1u1u7_14",
	chips: "_chips_1u1u7_23",
	hiddenTagsDropdown: "_hiddenTagsDropdown_1u1u7_32"
}, u = ({ className: u, tags: d, limit: f = d.length, tagClassName: p, onRemove: m, getHiddenTagsLabel: h = (e) => `+${e}`, ...g }) => {
	let { visibleTags: _, hiddenTags: v } = a(() => ({
		visibleTags: d.slice(0, f),
		hiddenTags: d.slice(f)
	}), [d, f]), y = (e) => /* @__PURE__ */ s(r, {
		wrapProps: { className: l.tooltip },
		content: e.name,
		children: /* @__PURE__ */ s(n, {
			className: p,
			color: e.color,
			disabled: e.is_deactivated,
			onDelete: m && (() => m(e)),
			children: e.name
		})
	}, e.id);
	return /* @__PURE__ */ c(t, {
		gap: "200",
		alignItems: "center",
		className: i(l.chips, u),
		...g,
		children: [_.map((e) => y(e)), v.length > 0 && /* @__PURE__ */ c(o, { children: [m && /* @__PURE__ */ s(e, {
			buttonProps: {
				variant: "tertiary",
				className: l.hiddenTagsDropdown
			},
			fixed: !0,
			dropdown: /* @__PURE__ */ s(t, {
				flexWrap: "wrap",
				gap: "100",
				padding: "200 300",
				width: "100%",
				maxWidth: "300px",
				children: v.map((e) => y(e))
			}),
			children: h(v.length)
		}), !m && /* @__PURE__ */ s(r, {
			className: l.placeholderTooltip,
			wrapProps: { className: l.tooltip },
			content: /* @__PURE__ */ s(t, {
				flexWrap: "wrap",
				gap: "100",
				children: v.map((e) => y(e))
			}),
			light: !0,
			children: /* @__PURE__ */ s(n, {
				noTruncation: !0,
				className: l.placeholderTagChip,
				children: h(v.length)
			})
		})] })]
	});
};
//#endregion
export { u as TagChips };

//# sourceMappingURL=index.js.map